/**
 * This script handles product compare
 */
import * as Cookies from 'js-cookie';

const cookieInstance = Cookies.withConverter({
	read(value) {
		return value;
	},
	write(value) {
		return value;
	},
});

/**
 * Gets the product compare data from cookie
 *
 * @returns {Array} Array of product compare
 */
export function getCookieData() {
	return JSON.parse(cookieInstance.get('productCompare') || '[]');
}

/**
 * method gets array index of item with productId
 *
 * @param {Array}    array  array to search for
 * @param {string}   id     product id
 * @returns {number} index
 */
function getArrayIndex(array: Array<any>, id: string) {
	return array.findIndex((el: any) => {
		return `${el.number}` === `${id}`;
	});
}

/**
 * method saves data to cookie
 *
 * @param {Object} data cookiedate
 * @returns {void}
 */
function saveCookie(data: object) {
	cookieInstance.set('productCompare', JSON.stringify(data));
}

/**
 * method updates compare layer
 *
 * @returns {void}
 */
export function updateLayer(): void {
	const $compareLayerModule = $("[data-t-name='ProductCompareLayer']");
	if ($compareLayerModule.length) {
		const count = getCookieData().length;
		if (count > 0) {
			if (parseInt(cookieInstance.get('productCompareHidden'), 10) !== count) {
				cookieInstance.remove('productCompareHidden');
				$compareLayerModule.trigger('showLayer', count);
			}
		} else {
			$compareLayerModule.trigger('hideLayer');
		}
	}
}

/**
 * method add compare layer
 *
 * @returns {void}
 */
export function addNewProductLayer(id: string, market: string, name: string): void {
	const $compareLayerModule = $("[data-t-name='ProductCompareLayer']");
	$compareLayerModule.trigger('addNewProductLayer', {number: id, market: market, name: name});
}

/**
 * method add compare layer
 *
 * @returns {void}
 */
export function removeNewProductLayer(id: string): void {
	const $compareLayerModule = $("[data-t-name='ProductCompareLayer']");
	$compareLayerModule.trigger('removeNewProductLayer', id);
}

/**
 * when handle the remove action from compare list, we also need to change the button state in finder list.
 *
 * @returns {void}
 */
export function removeCompareProductLayerFromFinderList(id: string): void {
	const $compareLayerModule = $("[data-t-name='ProductCompareButton']");
	$compareLayerModule.trigger('onCompareProductListItemChangeEvent', id);
}

/**
 * method will set hide layer cookie
 *
 * @param {string} id  productid string
 * @returns {void}
 */
export function setLayerHiddenCookie() {
	cookieInstance.set('productCompareHidden', getCookieData().length);
}

/**
 * method removes entry from product data
 *
 * @param {string} id  productid string
 * @returns {void}
 */
function removeProductData(id: string) {
	const cookieVal = getCookieData();
	const index = getArrayIndex(cookieVal, id);
	if (index > -1) {
		cookieVal.splice(index, 1);
	}
	return cookieVal;
}

/**
 * method removes entry from cookie
 *
 * @param {string} id  productid
 * @returns {void}
 */
export function removeProduct(id: string) {
	saveCookie(removeProductData(id));
	removeNewProductLayer(id);
	updateLayer();
}

/**
 * method empty product compare from cookie
 *
 * @returns {void}
 */
export function removeAllProduct() {
	cookieInstance.remove('productCompare');
}

/**
 * method updates adds product to cookie
 *
 * @param {string} id      productid
 * @param {string} market  market
 * @returns {void}
 */
export function addProduct(id: string, market: string, name: string) {
	const cookieVal = removeProductData(id);
	cookieVal.push({
		number: `${id}`,
		market,
		name: name,
	});
	saveCookie(cookieVal);
	addNewProductLayer(id, market, name);
	updateLayer();
}

/**
 * method updates cookie state
 *
 * @param {string} id  id of product
 * @returns {void}
 */
export function isProductInCookie(id: string) {
	return getArrayIndex(getCookieData(), id) > -1;
}
